export default __webpack_public_path__ + "static/media/GRAB.0fd5411d.svg";